import { combineReducers } from '@reduxjs/toolkit';
import { reducer as redeemCouponReducer } from './services/redeem';
import { reducer as couponListReducer } from './services/list';

export const reducer = combineReducers({
  redemption: redeemCouponReducer,
  list: couponListReducer,
});
